module.exports = __webpack_public_path__ + "img/product-img_5.56875a83.png";